function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IlocationFill = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "23",
    height: "32",
    viewBox: "0 0 23 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.14214 0 0 5.14432 0 11.5049C0 18.3585 7.26143 27.8089 10.2514 31.4083C10.9086 32.1972 12.1079 32.1972 12.765 31.4083C15.7386 27.8089 23 18.3585 23 11.5049C23 5.14432 17.8579 0 11.5 0ZM11.5 15.6138C10.4107 15.6138 9.36605 15.1809 8.59581 14.4103C7.82557 13.6397 7.39286 12.5946 7.39286 11.5049C7.39286 10.4151 7.82557 9.37002 8.59581 8.59946C9.36605 7.82889 10.4107 7.39599 11.5 7.39599C12.5893 7.39599 13.634 7.82889 14.4042 8.59946C15.1744 9.37002 15.6071 10.4151 15.6071 11.5049C15.6071 12.5946 15.1744 13.6397 14.4042 14.4103C13.634 15.1809 12.5893 15.6138 11.5 15.6138Z",
    fill: "black"
  }));
});